module.exports = __webpack_public_path__ + "static/img/bigEwm2.81de0c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/bigEwm2.png
// module id = ZXsH
// module chunks = 0